package linkerpangoquipdb

import kotlin.Long
import kotlin.String

public data class User_table(
  public val id: String?,
  public val email: String?,
  public val name: String?,
  public val avatar: String?,
  public val updated_at: Long?,
)
